import React, { ButtonHTMLAttributes, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
import { FaTh } from 'react-icons/fa';
import { AiOutlineRight } from "react-icons/ai";
import { BsFillGrid3X3GapFill, BsGrid3X3GapFill } from "react-icons/bs";
import { history } from '../config/store';

import Text from './Text';

export interface BreadCrumbProps {
  children: any[]
}




const BreadCrumb: React.FC<BreadCrumbProps> = ({
  children
}) => {
  const classes = useStyles();
  const handleDecreamentQty = useCallback((element) => {
    let path = "/search?"
      console.log(element)
    if (element.type == "subcategoryId") {
      path += "subCategoryId=" + element.id + "&categoryId=" + element.category_id
    } else if (element.type == "categoryId") {
      path += "categoryId=" + element.id
    }
    console.log(path)
    history.push(path);

  }, []);
  return (
    <div>
      <ul className={classes.crumbs}>
        <li className={clsx(classes.crumbsChild, classes.icon)}>
          <BsGrid3X3GapFill />
        </li>
        {
          children.map((item, index) => (
            <div key={index}>
              <li onClick={() => handleDecreamentQty(item)} className={classes.crumbsChild}>
                <Text className={clsx(classes.crumbsText, index + 1 == children.length ? classes.crumbsActiveText : "")}>{item.label} </Text>
              </li>
              {
                index + 1 != children.length ?
                  <li className={clsx(classes.crumbsChild, classes.iconArrow)}>
                    <AiOutlineRight />
                  </li> : null

              }
            </div>
          ))
        }
        {/* {
          children.map((item, index) => (
            <li key={index}>
              <li className={classes.crumbsChild}>
                <Text className={clsx(classes.crumbsText, index + 1 == children.length ? classes.crumbsActiveText : "")}>{item.label} </Text>
              </li>
              {
                index + 1 != children.length ?
                  <li className={clsx(classes.crumbsChild, classes.iconArrow)}>
                    <AiOutlineRight />
                  </li> : null

              }
            <li/>
          ))
        } */}
      </ul>
    </div>
  );
};

export const useStyles = createUseStyles({
  crumbs: {
    display: "flex"
  },
  crumbsChild: {
    display: "block",
    float: 'left',
    padding: "0px 5px",
    "&:first-child": {
      padding: "0px 5px 0px 0px"

    }
  },
  icon: {
    color: "#522583",
    fontSize: "1.5rem"
  },
  iconArrow: {
    fontSize: "1.3rem",
    paddingTop: "5px",
    color: "#b3b3b3"
  },
  crumbsText: {
    color: "#b3b3b3 !important",
    padding: "10px 0px",
  },
  crumbsActiveText: {
    color: "#522583 !important",
  }
});

export default BreadCrumb;
